import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import '../assets/css/main.css';

const FeatureCards = () => {
    const features = [
        {
            icon: "bi-person-badge",
            title: "Career Counseling",
            description: "Assisting students in recognizing their individual talents, enthusiasms, and targets so that they may determine suitable career paths.",
            className: "orange",
        },
        {
            icon: "bi-building",
            title: "Admission Guidance",
            description: "Tailoring support to applicants as they seek out specific colleges and universities including which courses to apply for as well as obtaining funding through scholarships.",
            className: "blue",
        },
        {
            icon: "bi-people",
            title: "Personalized Mentorship",
            description: "Allowing assisted mentoring to assist a person in learning and transitioning through school and into a career.",
            className: "green",
        },
        {
            icon: "bi-book",
            title: "Test Preparation",
            description: "Providing materials and teaching for entrance examinations, skills testing and further training.",
            className: "red",
        },
    ];
    
    return (
        <section id="features-cards" className="features-cards section">
            <div className="container">
                <div className="row gy-4">
                    {features.map((feature, index) => (
                        <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={(index + 1) * 100} key={index}>
                            <div className={`feature-box ${feature.className}`}>
                                <i className={`bi ${feature.icon} icon`}></i> 
                                <h4>{feature.title}</h4>
                                <p>{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeatureCards;